<template>
  <main id="userAbout" v-if="config.status.authed">
    <v-tabs centered icons-and-text color="transparent">
      <v-tabs-slider color="amber"></v-tabs-slider>
      <v-tab v-for="item in authedNavigation" :key="item.path" :to="item.path">
        {{ item.meta.label }}
        <font-awesome-icon :icon="item.meta.icon"></font-awesome-icon>
      </v-tab>
    </v-tabs>
    <router-view ref="content" class="content" @emit="emitted"></router-view>
    <v-footer fixed inset app height="auto" color="amber" class="pa-2">
      <v-layout>
        <v-btn v-if="isEditing" flat
          color="blue darken-2"
          @click="close">止める</v-btn>
        <v-spacer></v-spacer>
        <v-btn v-if="!isEditing" depressed
          class="blue darken-2 white--text"
          :loading="isLoading"
          @click="edit"><font-awesome-icon :icon="['fal', 'pencil']"/>&nbsp;編集する</v-btn>
        <v-btn v-if="isEditing" depressed
          color="blue darken-2 white--text"
          :loading="isLoading"
          :disabled="$refs.content == null || !$refs.content.isValid"
          @click="submit"><font-awesome-icon :icon="['fal', 'check']"></font-awesome-icon>&nbsp;保存する</v-btn>
      </v-layout>
    </v-footer>
  </main>
</template>

<script>
import UserAboutRoutes from '@/router/user/about'
export default {
  name: 'userAbout',
  components: {
  },
  data () {
    return {
      config: {
        status: {
          loading: true,
          editing: false,
          authed: true
        }
      }
    }
  },
  created () {
    this.init()
  },
  methods: {
    init: function () {
    },
    auth: function () {
    },
    state: function (req) {
      if (
        req.type &&
        req.status != null &&
        this.config.status[req.type] != null
      ) {
        this.$set(this.config.status, req.type, req.status)
      }
    },
    edit: function () {
      this.$refs.content.prepare()
    },
    submit: function () {
      this.$refs.content.submit()
    },
    close: function () {
      this.$set(this.config.status, 'editing', false)
      this.$refs.content.close()
    },
    emitted: function (req) {
      if (
        req &&
        req.action &&
        typeof this[req.action] === 'function'
      ) {
        this[req.action](req.data)
      }
    }
  },
  computed: {
    isLoading () {
      return !!this.config.status.loading
    },
    isEditing () {
      return !!this.config.status.editing
    },
    authedNavigation () {
      return UserAboutRoutes.routes.map(rt => {
        return Object.assign({}, rt, {
          path: `/u/about/${rt.path}`
        })
      })
    }
  }
}
</script>

<style lang="scss">
#userAbout {
  position: relative;
  .content {
    position: relative;
    width: 100%;
    height: calc(100% - 72px);
    z-index: 0;
    background: $white;
    .abt-item {
      max-width: 700px;
      margin: 0 auto;
    }
  }
}
@media screen and (max-width: $lg_screen_w) {
  #userAbout {
    .content {
      .abt-items {
        &.multi {
          display: block;
          max-width: 700px;
          .abt-column {
            width: 100%;
            margin: 0 auto;
            &:first-of-type {
              border-bottom: 1px solid $bb_c;
            }
          }
        }
      }
    }
  }
}
</style>
